import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import SecurityRepositoryImpl from './SecurityRepositoryImpl';

const securityRepository = new SecurityRepositoryImpl(fetcherAmplify);

export { securityRepository };
